/**
 * `Ф0` (кабинет): куда писать, если места нет или доступ закрыт.
 *
 * Адрес — один на кабинет; при смене поддержки правится здесь, а не в трёх
 * страницах. Названное в сдаче: адрес подлежит подтверждению.
 */
export const SUPPORT_EMAIL = "support@bma-gp.ru";

export const SUPPORT_LINK = `mailto:${SUPPORT_EMAIL}`;
